import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layouts';
Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: '/',
        component: Layout,
        children: [{
                path: '/:lang(en_US|zh_CN)?/',
                name: 'newHome',
                component: () =>
                    import ('../views/newHome/index.vue')
            },
            {
                path: '/home',
                name: 'home',
                redirect: '/newHome',
                component: () =>
                    import ('../views/home/index.vue')
            },
            {
                path: '/newHome',
                name: 'newHome',
                component: () =>
                    import ('../views/newHome/index.vue')
            },

            {
                path: '/category',
                name: 'category',
                component: () =>
                    import ('../views/category/index.vue')
            },
            {
                path: '/customerInsight',
                name: 'customerInsight',
                component: () =>
                    import ('../views/customerInsight/index.vue')
            },
            {
                path: '/marketingStrategy',
                name: 'marketingStrategy',
                component: () =>
                    import ('../views/marketingStrategy/index.vue')
            },
            {
                path: '/popularFeelings',
                name: 'popularFeelings',
                component: () =>
                    import ('../views/popularFeelings/index.vue')
            },
            {
                path: '/introducePage',
                name: 'introducePage',
                component: () =>
                    import ('../views/introducePage/introducePage.vue')
            },
            {
                path: '/tutorialPage',
                name: 'tutorialPage',
                component: () =>
                    import ('../views/tutorialPage/tutorialPage.vue')
            },
            {
                path: '/updateLog',
                name: 'updateLog',
                component: () =>
                    import ('../views/updateLog/index.vue')
            },
            {
                path: '/illustrateAI',
                name: 'illustrateAI',
                component: () =>
                    import ('../views/illustrateAI/illustrateAI.vue')
            },
            {
                path: '/openPlatform',
                name: 'openPlatform',
                component: () =>
                    import ('../views/openPlatform/openPlatform.vue')
            },
            {
                path: '/inviteFriendsPage',
                name: 'inviteFriendsPage',
                redirect: '/',
                component: () =>
                    import ('../views/inviteFriendsPage/inviteFriendsPage.vue')
            },
            {
                path: '/comparisonPage',
                name: 'comparisonPage',
                component: () =>
                    import ('../views/comparisonPage/comparisonPage.vue')
            },
            {
                path: '/downloadClient',
                name: 'downloadClient',
                component: () =>
                    import ('../views/downloadClient/download.vue')
            },
            {
                path: '/claw',
                name: 'aiClaw',
                component: () =>
                    import ('../views/claw/AIClaw.vue')
            },
            {
                path: '/aipcPage',
                name: 'aipcPage',
                component: () =>
                    import ('../views/aipcPage/aipcPage.vue')
            },
            {
                path: '/aiPPT',
                name: 'aiPPT',
                component: () =>
                    import ('../views/aiPPT/aiPPT.vue')
            },
            {
                path: '/aboutUs',
                name: 'aboutUs',
                component: () =>
                    import ('../views/aboutUs/aboutUs.vue')
            },
            {
                path: '/aippt_lesson',
                name: 'aippt_lesson',
                component: () =>
                    import ('../views/aipptLesson/aippt_lesson.vue')
            },
            {
                path: '/aiReport',
                name: 'aiReport',
                component: () =>
                    import ('../views/aiReport/aiReport.vue')
            },
            {
                path: '/ai_table',
                name: 'ai_table',
                component: () =>
                    import ('../views/aiTable/ai_table.vue')
            },
            {
                path: '/aiMax',
                name: 'aiMax',
                component: () =>
                    import ('../views/aiMax/aiMax.vue')
            },
            {
                path: '/enterprise',
                name: 'enterprise',
                component: () =>
                    import ('../views/enterprise/enterprise.vue')
            },
            {
                path: '/openAI4S',
                name: 'openAI4S',
                component: () =>
                    import ('../views/openai4s/openai4s.vue')
            },

        ]
    },



    {
        path: '/downloadhp',
        name: 'downloadhp',
        component: () =>
            import ('../views/download_hp/download_hp.vue')
    },
    {
        path: '/yuanYuan',
        name: 'yuanYuan',
        component: () =>
            import ('../views/yuanYuan/yuanYuan.vue')
    },
    {
        path: '/price',
        name: 'price',
        component: () =>
            import ('../views/home/price.vue')
    },
    {
        path: '/priceDialog',
        name: 'priceDialog',
        component: () =>
            import ('../views/home/priceDialog.vue')
    },
    {
        path: '/vocPage',
        name: 'vocPage',
        component: () =>
            import ('../views/illustrateAI/vocPage.vue')
    },
    {
        path: '/servicePage',
        name: 'servicePage',
        component: () =>
            import ('../views/illustrateAI/servicePage.vue')
    },
    {
        path: '/flowPath',
        name: 'flowPath',
        component: () =>
            import ('../views/flowPath/index.vue')
    },
    {
        path: '/UserAgreement',
        component: () =>
            import ('../views/h5/UserAgreement.vue')
    },
    {
        path: '/PrivacyAgreement',
        component: () =>
            import ('../views/h5/PrivacyAgreement.vue')
    },
    {
        path: '/assembly',
        name: 'assembly',
        component: () =>
            import ('../views/assembly/index.vue')
    },
    {
        path: '/loginDialogPage',
        name: 'loginDialogPage',
        component: () =>
            import ('../views/loginDialogPage/index.vue')
    },
    {
        path: '/mobileEndPage',
        name: 'mobileEndPage',
        component: () =>
            import ('../views/mobileEndPage/index.vue')
    },
    {
        path: '/amdAiMaxStation',
        name: 'amdAiMaxStation',
        component: () =>
            import ('../views/AMD/index.vue')
    },
    {
        path: '/announcementPage',
        name: 'announcementPage',
        component: () =>
            import ('../views/announcementPage/announcementPage.vue')
    },


    // {
    //   path: '/loginDIalog',
    //   name: 'loginDIalog',
    //   component: () => import('../components/loginDIalog/index.vue')
    // },


]

const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    // base: process.env.BASE_URL,
    base: '/homesite/',
    routes
})

export default router